import storage from 'redux-persist/lib/storage';

export const SET_USER_CURRENT_SELECTED_ROLE = 'SET_USER_CURRENT_SELECTED_ROLE';
export const SET_USER_CURRENT_SELECTED_ROLE_LISTENER = 'SET_USER_CURRENT_SELECTED_ROLE_LISTENER';
export const SET_CURRENT_USER_ROLE = 'SET_CURRENT_USER_ROLE';
export const SET_USER_IS_CONNECTED = 'SET_USER_IS_CONNECTED';
export const SET_USER_TOKEN = 'SET_USER_TOKEN';
export const SET_USER_PROFILE = 'SET_USER_PROFILE';
export const SET_USER_PROFILE_LISTENER = 'SET_USER_PROFILE_LISTENER';

export const persistUserConfig = {
    key: 'user',
    storage
};

export interface UserState {
    userCurrentSelectedRoleState: string | null;
    userCurrentSelectedRoleListenerState: string | null;
    userCurrentSelectedRoleListenerData: any | null;
    userCurrentSelectedRoleListenerError: any | null;
    userIsConnected: boolean | null;
    userToken: string | null;
    currentUserRole: string | null;
    userProfileData: {
        userProfileName: string,
        userToken: string,
        userId: number | undefined,
        role: string | undefined,
        name: string,
        email: string
    } | null;
    userProfileListenerState: string | null;
    userProfileListenerData: any | null;
    userProfileListenerError: any | null;
}

type UserAction =
    | { type: typeof SET_USER_IS_CONNECTED; payload: { userIsConnected: boolean } }
    | { type: typeof SET_USER_TOKEN; payload: { userToken: string } }
    | { type: typeof SET_USER_CURRENT_SELECTED_ROLE; payload: { currentUserRole: string } }
    | { type: typeof SET_CURRENT_USER_ROLE; payload: { userCurrentSelectedRoleState: string } }
    | { type: typeof SET_USER_PROFILE; payload: UserState['userProfileData'] }
    | { type: typeof SET_USER_PROFILE_LISTENER; payload: { state: string; data?: any; error?: any } }
    | { type: typeof SET_USER_CURRENT_SELECTED_ROLE_LISTENER; payload: { state: string; data?: any; error?: any } };

const initialState: UserState = {
    userCurrentSelectedRoleState: null,
    userCurrentSelectedRoleListenerState: null,
    userCurrentSelectedRoleListenerData: null,
    userCurrentSelectedRoleListenerError: null,
    userIsConnected: null,
    userToken: null,
    currentUserRole: null,
    userProfileData: null,
    userProfileListenerState: null,
    userProfileListenerData: null,
    userProfileListenerError: null
};

function UserReducer(state: UserState = initialState, action: UserAction): UserState {
    switch (action.type) {
    case SET_USER_IS_CONNECTED: {
        return Object.assign({}, state, {
            userIsConnected: action.payload.userIsConnected
        });
    }
    case SET_USER_TOKEN: {
        return Object.assign({}, state, {
            userToken: action.payload.userToken
        });
    }
    case SET_USER_CURRENT_SELECTED_ROLE: {
        return Object.assign({}, state, {
            currentUserRole: action.payload.currentUserRole
        });
    }
    case SET_CURRENT_USER_ROLE: {
        return Object.assign({}, state, {
            userCurrentSelectedRoleState: action.payload.userCurrentSelectedRoleState
        });
    }
    case SET_USER_PROFILE: {
        return Object.assign({}, state, {
            userProfileData: action.payload
        });
    }
    case SET_USER_PROFILE_LISTENER: {
        return Object.assign({}, state, {
            userProfileListenerState: action.payload.state,
            ...(action.payload.data !== undefined && {userProfileListenerData: action.payload.data}),
            ...(action.payload.error !== undefined && {userProfileListenerError: action.payload.error})
        });
    }
    case SET_USER_CURRENT_SELECTED_ROLE_LISTENER: {
        return Object.assign({}, state, {
            userCurrentSelectedRoleListenerState: action.payload.state,
            ...(action.payload.data !== undefined && {userCurrentSelectedListenerRoleData: action.payload.data}),
            ...(action.payload.error !== undefined && {userCurrentSelectedListenerRoleError: action.payload.error})
        });
    }
    default:
        return state;
    }
}

export default UserReducer;
